import { Realm } from "api/types";
import { ReactComponent as AnimalIcon } from "assets/icons/animal.svg";
import { ReactComponent as BoneIcon } from "assets/icons/bone.svg";
import { ReactComponent as PhysicsIcon } from "assets/icons/chemistry.svg";
import { ReactComponent as DnaIcon } from "assets/icons/dna.svg";
import { ReactComponent as InventionIcon } from "assets/icons/invention.svg";
import { ReactComponent as LeafIcon } from "assets/icons/leaf.svg";
import { ReactComponent as LightningIcon } from "assets/icons/lightning.svg";
import { ReactComponent as MathIcon } from "assets/icons/math.svg";
import { ReactComponent as MedicineIcon } from "assets/icons/medicine.svg";
import { ReactComponent as RocketIcon } from "assets/icons/rocket.svg";

export interface DisplayRealm {
	name: Realm;
	icon: JSX.Element;
	className: string;
}

export const realms: DisplayRealm[] = [
	{
		name: "Habiterra",
		icon: <AnimalIcon className="tagIcon" />,
		className: "animalTag",
	},
	{
		name: "Prehistoric Point",
		icon: <BoneIcon className="tagIcon" />,
		className: "paleontologyTag",
	},
	{
		name: "Green Acres",
		icon: <LeafIcon className="tagIcon" />,
		className: "environmentTag",
	},
	{
		name: "DNAtion",
		icon: <DnaIcon className="tagIcon" />,
		className: "evolutionTag",
	},
	{
		name: "Elixir Institute",
		icon: <MedicineIcon className="tagIcon" />,
		className: "medicineTag",
	},
	{
		name: "Edison's Isle",
		icon: <InventionIcon className="tagIcon" />,
		className: "inventionTag",
	},
	{
		name: "Pythagoras Peninsula",
		icon: <MathIcon className="tagIcon" />,
		className: "mathsTag",
	},
	{
		name: "E=MC Square",
		icon: <PhysicsIcon className="tagIcon" />,
		className: "physicsTag",
	},
	{
		name: "Cape Cosmos",
		icon: <RocketIcon className="tagIcon" />,
		className: "spaceTag",
	},
	{
		name: "Fahren Heights",
		icon: <LightningIcon className="tagIcon" />,
		className: "weatherTag",
	},
];

// Convert realms to an object for fast lookup
export type RealmMap = {
	[key in Realm]: DisplayRealm;
};

export const realmsMap = realms.reduce((acc, realm) => {
	acc[realm.name] = realm;
	return acc;
}, {} as RealmMap);
